import { Button, Tooltip } from '@salesforce/design-system-react';
import { useId } from 'react';

import { IconCategory } from '../../../shared/types/Enum';

interface FieldHelpTooltipProps {
  label: React.ReactNode;
}

// Small inline help affordance so business users get plain-language context without leaving the
// form — used next to any label whose terminology (bound, tier, contracted value...) isn't
// self-explanatory. Shared across features (Quality Formulas, Templates), not feature-specific.
export const FieldHelpTooltip: React.FC<FieldHelpTooltipProps> = ({ label }) => {
  const id = useId();

  return (
    <Tooltip align="top left" content={label} id={`field-help-tooltip-${id}`}>
      <Button
        aria-label="Field help"
        className="slds-shrink-none"
        iconCategory={IconCategory.Utility}
        iconName="info"
        variant="icon"
      />
    </Tooltip>
  );
};
